import { setIn } from 'final-form';
import type { ZodType } from 'zod';

type FormErrors = Record<string, unknown>;

const zodValidation =
  <Schema extends ZodType>(schema: Schema) =>
  async (data: unknown): Promise<FormErrors> => {
    const result = await schema.safeParseAsync(data);

    if (result.success) {
      return {};
    }

    return result.error.issues.reduce<FormErrors>(
      (formErrors, issue) => setIn(formErrors, issue.path.join('.'), issue.message) as FormErrors,
      {},
    );
  };

export default zodValidation;
